/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_EasierInputs */

const en_us2_swap_easier = /** @type {(inputs: Swap_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`easier`)
};

const pt_br2_swap_easier = /** @type {(inputs: Swap_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais fácil`)
};

const es_419_swap_easier = /** @type {(inputs: Swap_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más fácil`)
};

const pt_pt2_swap_easier = /** @type {(inputs: Swap_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais fácil`)
};

const fr_fr2_swap_easier = /** @type {(inputs: Swap_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plus facile`)
};

const de_de2_swap_easier = /** @type {(inputs: Swap_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leichter`)
};

const it_it2_swap_easier = /** @type {(inputs: Swap_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`più facile`)
};

/**
* | output |
* | --- |
* | "easier" |
*
* @param {Swap_EasierInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_easier = /** @type {((inputs?: Swap_EasierInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_EasierInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_easier(inputs)
	if (locale === "es-419") return es_419_swap_easier(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_easier(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_easier(inputs)
	if (locale === "de-DE") return de_de2_swap_easier(inputs)
	if (locale === "it-IT") return it_it2_swap_easier(inputs)
	return en_us2_swap_easier(inputs)
});
export { swap_easier as "swap.easier" }